import axios from 'axios';

export async function getMembershipPlanList(queryParams) {
  console.log('queryParams', queryParams);
  const params = {
    pageIndex: queryParams.pageNumber,
    pageSize: queryParams.pageSize,
    sortText: `${queryParams.sortField} ${queryParams.sortOrder}`,
    searchText: queryParams.filter.name,
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/MembershipPlan/Get`, params);
  return response.data;
}

export async function getMembershipPlanById(membershipPlanId) {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/MembershipPlan/${membershipPlanId}`
  );
  return response.data;
}

// Create =>  POST: add a new request to the server
export async function createUpdateMembershipPlan(membershipPlan) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/MembershipPlan`,
    membershipPlan
  );
  return response.data;
}

// DELETE => delete the request from the server
export async function deleteMembershipPlan(membershipPlanId) {
  const response = await axios.delete(
    `${process.env.REACT_APP_API_URL}/MembershipPlan?Id=${membershipPlanId}`
  );
  return response.data;
}

export async function getMembershipPlanNameList() {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/MembershipPlan/Name`);
  return response.data;
}
